<!--
 * @Author: TCS
 * @Date: 2020-03-10 15:32:45
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-29 14:37:30
 * @Description: file content
 -->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        岗位分类维护
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        >
          查询
        </el-button>
        <el-button
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        >
          重置
        </el-button>
        <el-button
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog('add')"
        >
          新增
        </el-button>
        <el-button
          type="success"
          icon="kestrel-icon ki-edit"
          plain
          :disabled="!selectedRow.roleTypeDm"
          @click="handleDialog('edit',selectedRow)"
        >
          修改
        </el-button>
        <el-button
          icon="kestrel-icon ki-trash-o"
          type="danger"
          :disabled="!selectedRow.roleTypeDm"
          @click="handleDel()"
        >
          删除
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :rules="filterParamsRules"
          :inline="true"
          label-position="right"
          label-width="90px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="岗位分类代码"
                label-width="10"
                prop="roleTypeDm"
              >
                <el-input
                  v-model.trim="filterParams.roleTypeDm"
                  class="c-form__input"
                  placeholder="岗位分类代码"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="岗位分类名称"
                label-width="10"
                prop="roleTypeName"
              >
                <el-input
                  v-model.trim="filterParams.roleTypeName"
                  class="c-form__input"
                  placeholder="岗位分类名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="岗位类型"
                label-width="10"
                prop="roleType"
              >
                <el-select
                  v-model="filterParams.roleType"
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择岗位类型"
                  clearable
                >
                  <el-option
                    v-for="item in enums.ROLE_TYPE"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <div
            class="c-page__pTable"
          >
            <!-- table的ref的命名根据业务名称修改 -->
            <el-table
              ref="listTable"
              class="c-page__table o-header-text-center"
              height="100%"
              stripe
              border
              highlight-current-row
              tooltip-effect="dark"
              :data="page.rows"
              :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
              @row-click="handleRowClick"
            >
              <el-table-column
                class-name="c-table-column--selection"
                width="30"
              >
                <template
                  slot-scope="scope"
                >
                  <el-radio
                    v-model="selectedRow.roleTypeDm"
                    :label="scope.row.roleTypeDm"
                  />
                </template>
              </el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="40"
                align="center"
              />
              <el-table-column
                prop="roleTypeDm"
                label="岗位分类代码"
                width="300"
                show-overflow-tooltip
              />
              <el-table-column
                prop="roleTypeName"
                label="岗位分类名称"
                show-overflow-tooltip
              />
              <!-- <el-table-column
                prop="roleTypeNameValue"
                label="岗位类型"
                show-overflow-tooltip
              /> -->
              <!-- <el-table-column prop="validName" label="有效标志" show-overflow-tooltip></el-table-column> -->
            </el-table>
            <el-pagination
              class="c-page__pagination"
              :disabled="page.total<=0||loading"
              :page-size="page.pageSize"
              :total="page.total"
              :current-page="page.pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[15,20,30]"
              @size-change="handleSizeChange"
              @current-change="search"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 新增 -->
    <add-dialog
      v-if="showDialogName==='add'"
      @closeDialog="handleDialog"
      @callback="search()"
    />

    <!-- 编辑 -->
    <edit-dialog
      v-if="showDialogName==='edit'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { roleTypeService } from './roleType.service.js';
import addDialog from './addDialog.vue';
import editDialog from './editDialog.vue';

export default {
  name: 'ListRoleType',
  components: {
    addDialog,
    editDialog
  },
  data () {
    return {
      loading: false, // 页面loading状态

      /* 查询条件（页面绑定的查询条件） Start */
      filterParams: {
        roleTypeDm: null, // 岗位分类代码
        roleTypeName: null // 岗位分类名称
      },
      /* 查询条件 End */

      /* 表单校验规则 Start */
      filterParamsRules: {},
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      selectedRow: {}, // 查询结果当前选中的行

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

    };
  },
  computed: {
    // 获取枚举
    enums () {
      return this.$HMStoreService.getEnums();
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @param {*}
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      roleTypeService.list(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 移除单选按钮选中行
          this.selectedRow = {};
        })
        .catch(err => {
          console.error('查询岗位分类出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 重置表单
     * @param {*}
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 选择单行触发的事件
     * @param {Object} val
     * @return {*}
     */
    handleRowClick (val) {
      this.selectedRow = val;
    },
    /**
     * @description: 点击删除按钮的事件
     * @param
     * @return {*}
     */
    handleDel () {
      const _this = this;
      _this.$confirm('此操作将永久删除该岗位分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        roleTypeService.delete(_this.selectedRow.roleTypeDm)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除错误！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    }
  }
};
</script>
